import { useState } from "react";
import Events from "./events";
import CombineDetails from "./details";

export default function Combines() {
  const [isAthleteSelected, setIsAthleteSelected] = useState(false);
  const [profileUpdateTrigger, setProfileUpdateTrigger] = useState(false);

  const handleBackButtonClick = (value) => {
    setIsAthleteSelected(value);
  };

  const updateProfilePicture = () => {
    setProfileUpdateTrigger((prev) => !prev);
  };

  return (
    <div className="flex-grow h-full">
      <div className="p-4 h-full bg-gray-100 sm:pb-80 mb:pb-50 xl:pb-0 lg:pb-0">
        <div className="flex flex-col xl:flex-row lg:flex-row gap-4 ">
          <div className="w-full lg:w-2/5 xl:w-2/5 h-full">
            <Events
              handleAttendeesClick={handleBackButtonClick}
              profileUpdateTrigger={profileUpdateTrigger}
            />
          </div>
          {isAthleteSelected && (
            <div className="w-full lg:w-3/5 xl:w-3/5">
              <CombineDetails
                backButtonClickEvent={handleBackButtonClick}
                updateProfilePicture={updateProfilePicture}
              />
            </div>
          )}

          {!isAthleteSelected && (
            <div className="w-full lg:w-3/5 xl:w-3/5 flex items-center justify-center min-h-[60vh]">
              <div className="w-full flex flex-col items-center justify-center">
                <img
                  alt="Athlete Name"
                  src="/select_row.svg"
                  className="object-cover h-20 pb-3 mx-auto"
                ></img>
                <p className="text-center text-[#8E8E93] text-1xl">
                  Select an event and attendee to start!
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
